import { soldGoodsRoutes } from '@app/sold-goods/sold-goods-routes';
import { Button } from '@shared/components/ui/button';
import { generatePath, useNavigate } from 'react-router-dom';

export default function SoldGoodsImportPageToolbar() {
  const navigate = useNavigate();
  return (
    <Button
      size="sm"
      data-testid="new-import-button"
      onClick={() => navigate(generatePath(soldGoodsRoutes.SOLD_GOODS_IMPORT))}
    >
      New import
    </Button>
  );
}
